import _ from 'lodash';
import { SubitemsSourceIndicator, SubitemsBoardSourceExplainer } from './SubitemsBoardSource';
import { ClientBoardSource, ClientBoardSourceExplainer, ClientBoardSourceIndicator } from './ClientBoardSource';
import { BoardBoardSource, BoardBoardSourceExplainer, BoardBoardSourceIndicator } from './BoardBoardSource';
import { SharedClientBoardSource, SharedClientBoardSourceExplainer, SharedClientBoardSourceIndicator } from './SharedClientBoardSource';

export const boardSourceDescriptors = [
  {
    type: 'subitems',
    name: 'Client Subitems',
    description: 'Show each client their subitems from the Clients Board',
    example: 'Each client item on the Clients Board contains subitems.',
    helpLink: 'https://getgorilla.app/products/client-portal/how-to-use/board-setup#show-each-client-their-subitems-from-the-clients-board',
    explainerComponent: SubitemsBoardSourceExplainer,
    indicatorComponent: SubitemsSourceIndicator,
    component: null,
    defaultValues: {
      type: 'subitems',
    },
    tag: '',
  },
  {
    type: 'shared-client-board',
    name: 'Shared Client Board',
    description: 'Show selected items to specific clients from a board',
    example: 'The board contains items for multiple different clients.',
    helpLink: 'https://getgorilla.app/products/client-portal/how-to-use/board-setup#show-selected-items-to-specific-clients-from-one-board',
    explainerComponent: SharedClientBoardSourceExplainer,
    indicatorComponent: SharedClientBoardSourceIndicator,
    component: SharedClientBoardSource,
    defaultValues: {
      type: 'shared-client-board',
    },
    tag: 'Popular',
  },
  {
    type: 'client-board',
    name: 'Single Client Board',
    description: 'Show each client their own dedicated and assigned board',
    example: 'Each client has their own board created from a single template board.',
    helpLink:
      'https://getgorilla.app/products/client-portal/how-to-use/board-setup#show-each-client-their-own-dedicated-and-assigned-board',
    explainerComponent: ClientBoardSourceExplainer,
    indicatorComponent: ClientBoardSourceIndicator,
    component: ClientBoardSource,
    defaultValues: {
      type: 'client-board',
    },
    tag: '',
  },
  {
    type: 'board',
    name: 'Shared Board',
    description: 'Show all items from a board to all clients',
    example: 'The board contains items meant for every client.',
    helpLink: 'https://getgorilla.app/products/client-portal/how-to-use/board-setup#show-all-items-from-one-board-to-all-clients',
    explainerComponent: BoardBoardSourceExplainer,
    indicatorComponent: BoardBoardSourceIndicator,
    component: BoardBoardSource,
    defaultValues: {
      type: 'board',
    },
    tag: '',
  },
] as const;

export const boardSourceDescriptorsByType = _.keyBy(boardSourceDescriptors, 'type');

export type BoardSourceDescriptorType = (typeof boardSourceDescriptors)[number]['type'];

export function BoardSourceIndicator({
  boardSourceType,
  children,
  hideHelpLink,
}: {
  boardSourceType: string;
  children?: React.ReactNode;
  hideHelpLink?: boolean;
}) {
  const IndicatorComponent = boardSourceDescriptorsByType[boardSourceType]?.indicatorComponent;

  if (!IndicatorComponent) {
    return null;
  }

  return (
    <IndicatorComponent helpLink={boardSourceDescriptorsByType[boardSourceType]?.helpLink} hideHelpLink={hideHelpLink}>
      {children}
    </IndicatorComponent>
  );
}
